<p-confirmDialog #discardTableDialog key="discardTableDialog">
  <ng-template pTemplate="headless">
    <ct-extraction-dialog
      acceptText="Verwerfen & Zurück"
      closeText="Abbrechen"
      title="Tabellenentwurf verwerfen"
      (acceptDialog)="acceptedDialog.emit(); discardTableDialog.onAccept()"
      (closeDialog)="discardTableDialog.onReject()">
      <p>
        Das Layout der Tabelle wurde bisher noch nicht abgeschlossen. Die Änderungen werden
        verworfen, wenn Du zurück zur Erfassung der Vorgangsdaten gehst.
      </p>
    </ct-extraction-dialog>
  </ng-template>
</p-confirmDialog>
